import { customInstance } from '@/features/auth/axios-config'

import { HttpMethod } from '../../utils/constants'

import type {
  GetPreferencesResponse,
  NotificationPreferences,
  UpdatePreferencesRequest,
  UpdatePreferencesResponse,
} from './types'
import { apiToUIPreferences, uiToAPIPreferences } from './utils'

const API_ENDPOINT_NOTIFICATION_PREFERENCES =
  '/admin/v1/notifications/preferences'

export const notificationPreferencesApi = {
  getPreferences: async (): Promise<NotificationPreferences> => {
    const response = await customInstance<GetPreferencesResponse>({
      method: HttpMethod.GET,
      url: API_ENDPOINT_NOTIFICATION_PREFERENCES,
    })

    // Extract first item from array and transform to UI format
    const apiPreferences = response.data[0]
    return apiToUIPreferences(apiPreferences)
  },

  updatePreferences: async (
    data: NotificationPreferences
  ): Promise<NotificationPreferences> => {
    const apiRequest: UpdatePreferencesRequest = uiToAPIPreferences(data)

    const response = await customInstance<UpdatePreferencesResponse>({
      method: HttpMethod.PUT,
      url: API_ENDPOINT_NOTIFICATION_PREFERENCES,
      data: apiRequest,
    })

    // Extract first item from array and transform to UI format
    const apiPreferences = response.data[0]
    return apiToUIPreferences(apiPreferences)
  },
}
